import { actionTypes } from "../../actions/action_types";

const initialState = {
  target_list: [],
};

export default function inventory_target_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_INVENTORY_TARGET_GET_OVERALL:
      stateCopy.target_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_INVENTORY_TARGET_GET_CLUSTER:
      stateCopy.target_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_INVENTORY_TARGET_GET_AREA:
      stateCopy.target_list = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
